define(function (require) {

	const DataModelStore = require('civicsBase/data_model_store');
	const Utils = require('civicsUtils/general_utilities');

	const BACKBONE_TYPE = 'backbone';
	const JAVASCRIPT_TYPE = 'javascript';

	function field_change_utilities(parentView, modelKeyParam) {
		let modelKey = modelKeyParam;

		this.setFieldChange = (callback) => {
     		let inputList =  parentView.$el.find('input:not([fieldchange])');

		 	let eventCallback = callback ? callback : this.defaultCallback.bind(parentView);

			$.each(inputList, (index, input) => {
				if( $(input).hasClass('droppy-input'))
					$(input).on('droppyClose', eventCallback);
				else
					$(input).on('focusout', eventCallback);
				$(input).attr("fieldchange","on");
			});
		}

		//Saves the form data in the data model store.
		this.defaultCallback = (e) => {

			let formData = Backbone.Syphon.serialize(parentView);

			let namespace = parentView.config.portletId;

			for(data in formData) {
				DataModelStore.updateProperty(namespace, modelKey, data, formData[data]);
			}

			//reload the elements that supports filter codes.
			this.reloadFilterCodes(parentView);
		}

		this.reloadFilterCodes = (parentView) => {
			parentView.$el.find('input[filterCodes]').each((index , element) => $(element).reloadFilterCodes());
		}

	}
	return field_change_utilities;
});
